// extracted by mini-css-extract-plugin
export default {"menuBlock":"MF-z","title":"NF-z","nav":"OF-z","flexCell":"PF-z","facetLink":"QF-z"};